import React, {useEffect, useState, useContext} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {TextField, InputLabel, createStyles, Theme as AugmentedTheme} from '@material-ui/core';
import { SET_EMAIL_IS_VALID } from '../../../store/types';
import { FormContext } from '../../../store/formContext';
import { emailValidationHelper } from '../../../utils/validationHelper'
import { CustomInputMappingField } from '@tuqqi/common';
interface IEmail {
    field: CustomInputMappingField,
    value: string,
    onChangeHandler: (e: React.ChangeEvent<HTMLInputElement>) => void,
    sourceField: string
    isRtl: boolean
}

const useStyles = makeStyles((theme: AugmentedTheme) =>  createStyles({
    field: {
        width: '100%',
        fontSize: '14px',
        fontWeight: 400,
        letterSpacing: '.2px',
        lineHeight: '20px',
        color: '#202124',

        "&::placeholder": {
            fontSize: '14px',
        },
    },
    emailWarning: {
        fontSize: 14,
        color: '#f44336',
    },
      //@ts-ignore
      inputLabel: theme.inputLabel,

      
    errorLabel: {
        color: '#f44336',
    }
}))


export default function EmailField({ field, value, onChangeHandler, sourceField, isRtl }: IEmail) {
    const classes = useStyles();

    const [error, setError] =useState<boolean>(false);

    const { dispatch } = useContext<any>(FormContext);

    useEffect(() => {
        if(value.length) {
            const isValid = emailValidationHelper(value);
            setError(!isValid);
            dispatch({type: SET_EMAIL_IS_VALID, payload: isValid, sourceField})

        }
    }, [value, dispatch, sourceField])


    useEffect(()=> {
        if(!value.length) {
            setError(false);
            dispatch({type: SET_EMAIL_IS_VALID, payload: true, sourceField})
        }
    }, [value, dispatch, sourceField])

    return(
        <>
          <InputLabel
           style={{ 
            direction: isRtl ? 'rtl' : 'ltr',
            textAlign: isRtl ? 'right' : 'left' 
        }} 
         htmlFor={field.sourceField} className={error ? `${classes.inputLabel} ${classes.errorLabel}` : classes.inputLabel}>{field.fieldName}</InputLabel>
            <TextField  
            style={{ 
                direction: isRtl ? 'rtl' : 'ltr',
                textAlign: isRtl ? 'right' : 'left' 
            }} 
                value={value} 
                id={field.sourceField} 
                className={classes.field} 
                placeholder={field.fieldName}
                onChange={onChangeHandler} 
                name={field.fieldName} 
                type={field.type} 
                required={field.required}
                error={error}                    
            />
            {error && <p className={classes.emailWarning}>Email is not valid!</p>}
        </>
    )
}